import $ from 'jquery';
$(document).ready(function () {

    var $registerForm = $('#register-personid-form');
    var $addPersonId = $('#add-personid-form');


    //ADD PERSONID 
    $addPersonId.on('validated', function(ev) {
        ev.preventDefault();
        var formData = $addPersonId.serialize();

        $.ajax({
            data: formData,
            url: $addPersonId.attr('action'),
            method: "POST",
            processData: false,
            success: function(response) {
                $('.personid-wrapper').fadeOut();
                $('#personIdRegistered').removeClass("d-none");
            },
            error: function(response) {
                $("#modalPersonIdFailed").modal();
            }
        });
    });

    //REGISTER PERSONID MODAL
    $('.register-personid-step-two').hide();
    $('.register-personid-step-three').hide();
    $('.register-personid-step-four').hide();
    $('.register-personid-failed').hide();

    $registerForm.on('validated', function(ev) {
        // Showing loading
        $('.register-personid-step-one').hide();
        $('.register-personid-step-two').show();

        ev.preventDefault();
        var formData = $registerForm.serialize();

        $.ajax({
            data: formData,
            url: $registerForm.attr('action'),
            method: $registerForm.attr('method'),
            processData: false,
            success: function(response) {
                $('.register-personid-step-two').hide();
                $('.register-personid-step-three').show();
            },
            error: function(response) {
                $('.register-personid-step-two').hide();
                $('.register-personid-step-four').show();
                $('.register-personid-failed').show();
            }
        });
    });

    $('#modalPersonId').on('hide.bs.modal',
        function(ev) {
            $(".modal-backdrop").remove();
            $("#modalPersonId").hide();
        });
    $('#company-select-list').on('change',
        function() {
            $(".company-wrapper").hide();
            $(".orderflow__processingorder").show();
            $.ajax({
                url: window.location.href + '/GetCompanyInformation?companyId=' + $(this).val(),
                method: 'GET',
                success: function(response) {
                    if (response.length) {
                        $('input[name ="companyName"]').val(response[0].Name);
                        $('input[name ="companyOrgNo"]').val(response[0].OrganizationNumber);
                        $('input[name ="companyStreet"]').val(response[0].Address.Street);
                        $('input[name ="companyPostalCode"]').val(response[0].Address.PostalCode);
                        $('input[name ="companyCity"]').val(response[0].Address.City);
                        $('input[name ="companyId"]').val(response[0].Id);
                        $('input[name ="companyExtId"]').val(response[0].ExternalId);
                        $('#company-checkbox').prop('checked', response[0].Primary);
                        $('#company-checkbox').prop('disabled', response[0].Primary === true);
                        $('#delete-company-modal-btn').toggleClass('d-none', response[0].Primary === true);
                        $('#delete-company-name').html(response[0].Name);
                        $('#delete-company').attr('href',
                            '@(Url.Action("DeleteCompany", "AccountInformation"))?companyId=' +
                            response[0].ExternalId);

                        var options = [];
                        response[0].Contacts.forEach(function(contact) {
                            options.push('<option value="' +
                                contact.ExternalId +
                                '">' +
                                contact.FirstName +
                                " " +
                                contact.LastName +
                                '</option>');
                        });
                        $('#companycontact-select-list').html(options.join());
                        $('#companycontact-select-list').trigger('change');
                        if (response[0].Contacts.length <= 1) {
                            $('.companycontact-select-wrapper').hide();
                        } else {
                            $('.companycontact-select-wrapper').show();
                        }
                    }
                }
            });
        });

    $('#companycontact-select-list').on('change',
        function(e) {
            $(".companycontact-wrapper").hide();
            $(".orderflow__processingorder").show();
            $.ajax({
                url: window.location.href +
                    '/GetCompanyContactInformation?companyId=' +
                    $('input[name ="companyExtId"]').val() +
                    '&contactId=' +
                    $(this).val(),
                method: 'GET',
                success: function(response) {
                    if (response.length) {
                        $('input[name ="firstName"]').val(response[0].FirstName);
                        $('input[name ="lastName"]').val(response[0].LastName);
                        $('input[name ="email"]').val(response[0].Email);
                        $('input[name ="phone"]').val(response[0].Phone);
                        $('input[name ="contactId"]').val(response[0].Id);
                        $('input[name ="contactExtId"]').val(response[0].ExternalId);
                        $('#companycontact-checkbox').prop('checked', response[0].Primary);
                        $('#companycontact-checkbox').prop('disabled', response[0].Primary === true);
                        $('#delete-companycontact-modal-btn')
                            .toggleClass('d-none', response[0].Primary === true);
                        $('#delete-contact-name').html(response[0].FirstName + " " + response[0].LastName);
                        $('#delete-company-contact').attr('href',
                            '@(Url.Action("DeleteCompanyContact", "AccountInformation"))?companyId=' +
                            $('input[name ="companyExtId"]').val() +
                            '&companyContactId=' +
                            response[0].ExternalId);
                        $(".orderflow__processingorder").hide();
                        $(".company-wrapper").show();
                        $(".companycontact-wrapper").show();
                    }
                }
            });
        });

    $('#contact-select-list').on('change',
        function() {
            $(".contact-wrapper").hide();
            $(".orderflow__processingorder").show();
            $.ajax({
                url: window.location.href + '/GetContactInformation?contactId=' + $(this).val(),
                method: 'GET',
                success: function(response) {
                    if (response.length) {
                        $('input[name ="firstName"]').val(response[0].FirstName);
                        $('input[name ="lastName"]').val(response[0].LastName);
                        $('input[name ="street"]').val(response[0].Address.Street);
                        $('input[name ="postalCode"]').val(response[0].Address.PostalCode);
                        $('input[name ="city"]').val(response[0].Address.City);
                        $('input[name ="email"]').val(response[0].Email);
                        $('input[name ="phone"]').val(response[0].Phone);
                        $('input[name ="contactId"]').val(response[0].Id);
                        $('input[name ="contactExtId"]').val(response[0].ExternalId);
                        $('#contact-checkbox').prop('checked', response[0].Primary);
                        $('#contact-checkbox').prop('disabled', response[0].Primary === true);
                        $('#delete-contact-modal-btn').toggleClass('d-none', response[0].Primary === true);
                        $('#delete-contact-name').html(response[0].FirstName + " " + response[0].LastName);
                        $('#delete-contact').attr('href',
                            '@(Url.Action("DeleteContact", "AccountInformation"))?contactId=' +
                            response[0].ExternalId);
                        $(".orderflow__processingorder").hide();
                        $(".contact-wrapper").show();
                    }
                }
            });
        });
});
